import Vue from 'vue'
import { setToken } from '@/utils/helper'

let queue = {} // 存储请求队列
let requestCount = 0 // 请求次数
let seed = 1 // 请求hash编号
let isSessionLost = false // 凭证是否丢失

// axios watcher
const watcher = Object.assign(new Vue(), {
    // 请求开始
    requestStart(req) {
        seed++
        requestCount++
        queue[seed] = {
            req
        }

        req._seed = seed

        return seed
    },

    // 请求结束
    requestDone(res) {
        var done = --requestCount <= 0,
            config = res.config,
            data = res.data

        // 记录res
        if (config) {
            queue[config._seed].res = res
        }

        if (data && data.code && data.code === 403 || res.status == 403) {
            // 凭证已过期
            setToken('')
            isSessionLost = true
        }

        // 请求结束
        this.$emit("requestDone", res)

        // 当一个事件循环内的所有异步请求都执行完毕时
        if (done) {
            // 请求处理完成后事件
            this.$emit("requestLoopEnded",
                Object.keys(queue).reduce((pre, i) => {
                    pre.push(queue[i])

                    return pre
                }, []))

            // 会话丢失事件
            if (isSessionLost) {
                this.$emit("sessionLost")
                isSessionLost = false
            }

            queue = {}
            requestCount = 0
        }
    },
})

export default watcher